import {defineStore} from 'pinia'
import {http} from '@/extensions/http/index.js'
import {API_ENDPOINTS} from '@/config/index.js'

export const useEmployeeStore = defineStore('employee', {
    state: () => {
        return {
            all: null
        }
    },
    actions: {
        async init() {
            try {
                if (this.all) return

                const {data} = await http.get(API_ENDPOINTS.EMPLOYEE.INDEX)

                this.all = data
            } catch { /**/ }
        },
        async destroy(id) {
            try {
                await http.delete(API_ENDPOINTS.EMPLOYEE.DESTROY.replace(':id', id))

                this.all = this.all.filter(employee => employee.id.toString() !== id.toString())
            } catch { /**/ }
        },
        async store(payload) {
            try {
                const {data} = await http.post(API_ENDPOINTS.EMPLOYEE.STORE, payload)

                this.all.push(data)

                return data.id
            } catch { /**/ }
        },
        async update(id, payload) {
            try {
                const {data} = await http.put(API_ENDPOINTS.EMPLOYEE.UPDATE.replace(':id', id), payload)

                this.all = this.all.map(employee => {
                    if (employee.id.toString() === id.toString()) {
                        employee = data
                    }

                    return employee
                })
            } catch { /**/ }
        }
    }
})